import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUpworkComponent } from './simple-icons-upwork.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUpworkComponent ],
    exports:      [ SimpleIconsUpworkComponent ],
    bootstrap:    []
})
export class SimpleIconsUpworkModule {}
